import React from "react";
import { Chip, Hidden, Typography } from "@material-ui/core";
import "../navbar.css";
import {
  faYoutube,
  faLinkedin,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Navbar = () => {
  const expand = (e) => {
    console.log("working");
    var menu = document.querySelector("#menu");
    console.log(menu);
    menu.classList.toggle("hidden");
  };
  return (
    <div>
      <nav id="mobileNav" className="bg-white">
        <div className="md:py-0 my-2 flex-shrink-0">
          <a href="/"><img
            src="https://www.khuranaandkhurana.com/wp-content/uploads/2023/07/knk-logo1.png"
            width={350}
          /></a>
          <Typography color={"primary"} style={{ fontSize: 14 }}>
            An ISO 9001:2015 Certified Firm
          </Typography>
        </div>
        <nav
          class="
          flex flex-wrap bg-red-700
          items-center
          justify-between
          w-full
          py-4
          md:py-0
          px-4
          text-lg text-gray-700
          bg-white
        "
        >
          <div>
            <a href="https://www.khuranaandkhurana.com/">
              <strong class="text-amber-700">
                Khurana<i> & </i>Khurana
              </strong>
            </a>
          </div>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            onClick={expand}
            id="menu-button"
            class="h-6 w-6 cursor-pointer md:hidden block"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>

          <div
            class="hidden w-full md:flex md:items-center md:w-auto"
            id="menu"
          >
            <ul
              class="
              pt-4
              text-base text-gray-700
              md:flex
              md:justify-between 
              md:pt-0"
            >
              <li>
                <a
                  class="md:p-4 py-2 block hover:text-amber-700"
                  href="https://www.khuranaandkhurana.com/memberships-awards/"
                >
                  <strong>MEMBERSHIP & AWARDS</strong>
                </a>
              </li>
              <li>
                <a
                  class="md:p-4 py-2 block hover:text-amber-700"
                  href="https://www.khuranaandkhurana.com/frequently-asked-questions-faqs/"
                >
                  <strong>FAQS</strong>
                </a>
              </li>
              <li>
                <a
                  class="md:p-4 py-2 block hover:text-amber-700"
                  href="https://www.khuranaandkhurana.com/pro-bono/"
                >
                  <strong>PRO BONO</strong>
                </a>
              </li>
              <li>
                <a
                  class="md:p-4 py-2 block hover:text-amber-700"
                  href="https://www.khuranaandkhurana.com/careers-internships/"
                >
                  <strong>CAREERS & INTERNSHIPS</strong>
                </a>
              </li>
              <li>
                <a
                  class="md:p-4 py-2 block hover:text-amber-700"
                  href="https://www.khuranaandkhurana.com/contact/"
                >
                  <strong>CONTACT US</strong>
                </a>
              </li>
              <li>
                <a
                  class="md:p-4 py-2 block hover:text-amber-700"
                  href="https://iiprd-khuranaandkhurana-cms.com/"
                >
                  <strong>Clinet Login</strong>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </nav>

      <div className="" id="bigNav">
        <nav className="w-full bg-white items-center flex">
          <div className="md:py-0  w-2/5 my-2 flex-shrink-0 pr-2">
            <a href="/">
              <img
                src="https://www.khuranaandkhurana.com/wp-content/uploads/2023/07/knk-logo1.png"
                width={450}
              />
            </a>
            <Typography style={{ color: "#9c490e", fontSize: 13 }}>
              &nbsp;An ISO 9001:2015 Certified Firm
            </Typography>
          </div>
          <ul className="md:pl-0 ml-auto md:flex flex-row md:space-x-2 w-3/5 items-center absolute md:relative top-full left-0 right-0">
            <li>
              <a
                href="https://www.khuranaandkhurana.com/memberships-awards/"
                className="flex md:inline-flex p-2 py-6 items-center nav-item"
              >
                <span style={{ fontSize: 13 }}>
                  MEMBERSHIP
                  <br />& AWARDS
                </span>
              </a>
            </li>
            <li>
              <a
                href="https://www.khuranaandkhurana.com/frequently-asked-questions-faqs/"
                className="flex md:inline-flex p-2 py-6 items-center nav-item"
              >
                <span style={{ fontSize: 13 }}>FAQS</span>
              </a>
            </li>
            <li>
              <a
                href="https://www.khuranaandkhurana.com/pro-bono/"
                className="flex md:inline-flex p-2 py-6 items-center nav-item"
              >
                <span style={{ fontSize: 13 }}>PRO BONO</span>
              </a>
            </li>
            <li>
              <a
                href="https://www.khuranaandkhurana.com/careers-internships/"
                className="flex md:inline-flex p-2 py-6 items-center nav-item"
              >
                <span style={{ fontSize: 13 }}>
                  CAREERS &<br />
                  INTERNSHIPS
                </span>
              </a>
            </li>
            <li>
              <a
                href="https://www.khuranaandkhurana.com/contact/"
                className="flex md:inline-flex p-2 py-6 items-center nav-item"
              >
                <span style={{ fontSize: 13 }}>CONTACT US</span>
              </a>
            </li>
            <li>
              <a
                href="https://iiprd-khuranaandkhurana-cms.com/"
                className="flex md:inline-flex p-2 py-6 items-center nav-item"
              >
                <Chip
                  style={{ cursor: "pointer","border-radius":5}}
                  color={"primary"}
                  label="CLIENT LOGIN"
                  className="hover:shadow-lg"
                />
                {/*<span className='' style={{fontSize:14, background:'#'}}>CLIENT LOGIN</span>*/}
              </a>
            </li>

            <li>
              <a
                className="icon"
                href="https://www.youtube.com/channel/UCIu2HgBG4rwf7VwtTPgPaog"
                target="_blank"
              >
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            </li>
            <li >
              <a
                className="icon"
                href="https://www.linkedin.com/company/khurana-&-khurana-advocates-and-ip-attorneys"
                target="_blank"
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </li>
            <li >
              <a
                className="icon"
                href="https://api.whatsapp.com/send/?lang=en&phone=918920269831&text=Hi%2C+we+need+assistance+regarding+IP%2Flegal+services&app_absent=0"
                target="_blank"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
              </a>
            </li>
          </ul>
        </nav>
        <Hidden smDown>
          <nav
            className="flex px-4 md:shadow items-center relative"
            style={{ backgroundColor: "#AB5212" }}
          >
            <ul className="md:pl-2 mx-auto p-0 max-w-6xl md:flex  items-center absolute md:relative top-full left-0 right-0">
              <li className='nav2-item flex-1 relative'>
                <a
                  href="https://www.khuranaandkhurana.com/"
                  className="flex md:inline-flex p-2 items-center"
                >
                  <span style={{ fontSize: 14 }}>HOME</span>
                </a>
                <ul className="child transition duration-300 md:absolute top-full md:w-64 md:shadow-lg">
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/knk-profile/"
                      className="flex px-4 py-1 child-item"
                    >
                      K&K Profile
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/managing-partner/"
                      className="flex px-4 py-1 child-item"
                    >
                      Core Practitioners
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/wp-content/uploads/2021/01/IIPRD_KK_Brochure.pdf"
                      className="flex px-4 py-1 child-item"
                    >
                      Corporate Brochure
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/wp-content/uploads/2021/06/Firm-Presentation-KK_2021.pdf"
                      className="flex px-4 py-1 child-item"
                    >
                      Corporate Presentation
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/corporate-induction-video/"
                      className="flex px-4 py-1 child-item"
                    >
                      Corporate Induction Video
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/informationdata-security-management/"
                      className="flex px-4 py-1 child-item"
                    >
                      Information/Data Security
                      <br /> Management
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav2-item pipe">
                |
              </li>
              <li className="nav2-item pl-0 pr-0 relative">
                <a
                  href="https://www.khuranaandkhurana.com/ip-protection-and-portfolio-management/"
                  className="flex border-r-1 md:inline-flex p-2 items-center nav2-item"
                >
                  <span style={{ fontSize: 14 }}>
                    IP PROTECTION & PORTFOLIO MANAGEMENT
                  </span>
                </a>
                <ul className="child transition duration-300 md:absolute top-full md:w-64 md:shadow-lg">
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/ip-protection-and-portfolio-management/patent-drafting-preparation/"
                      className="flex px-4 py-1 child-item"
                    >
                      Patent
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/ip-protection-and-portfolio-management/trade-mark-portfolio/"
                      className="flex px-4 py-1 child-item"
                    >
                      Trade Mark
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/ip-protection-and-portfolio-management/copyright-portfolio/"
                      className="flex px-4 py-1 child-item"
                    >
                      Copyright
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/ip-protection-and-portfolio-management/design-portfolio/"
                      className="flex px-4 py-1 child-item"
                    >
                      Design
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/product-design-and-prototyping/"
                      className="flex px-4 py-1 child-item"
                    >
                      Product Design And Prototyping
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/ip-protection-and-portfolio-management/geographical-indications/"
                      className="flex px-4 py-1 child-item"
                    >
                      Geographical Indications
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav2-item pipe">
                |
              </li>
              <li className="nav2-item relative">
                <a
                  href="https://www.khuranaandkhurana.com/infringement-of-intellectual-property-rights/"
                  className="flex md:inline-flex p-2 items-center nav2-item"
                >
                  <span style={{ fontSize: 14 }}>LITIGATION & ENFORCEMENT</span>
                </a>
                <ul className="child transition duration-300 md:absolute top-full md:w-64 md:shadow-lg">
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/infringement-of-intellectual-property-rights/ip-litigation/"
                      className="flex px-4 py-1 child-item"
                    >
                      IP Litigation
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/infringement-of-intellectual-property-rights/litigation-support/"
                      className="flex px-4 py-1 child-item"
                    >
                      Litigation Support
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/domain-name-resolution-practice/"
                      className="flex px-4 py-1 child-item"
                    >
                      Domain Name <br />
                      Resolution Practice
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/infringement-of-intellectual-property-rights/litigation-support/anti-counterfeiting-practice/"
                      className="flex px-4 py-1 child-item"
                    >
                      Anti Counterfeiting <br />
                      Practice
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav2-item pipe">
                |
              </li>
              <li className="nav2-item relative">
                <a
                  href="https://www.khuranaandkhurana.com/ip-advisory-and-opinions/"
                  className="flex md:inline-flex p-2 items-center nav2-item"
                >
                  <span style={{ fontSize: 14 }}>ADVISORIES & OPINIONS</span>
                </a>
                <ul className="child transition duration-300 md:absolute top-full md:w-64 md:shadow-lg">
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/ip-advisory-and-opinions/patent-search-mapping-analysis/"
                      className="flex px-4 py-1 child-item"
                    >
                      Patent Search Mapping & Analysis
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/ip-advisory-and-opinions/due-diligence-services/"
                      className="flex px-4 py-1 child-item"
                    >
                      Due-Diligence Services
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/ip-advisory-and-opinions/building-ip-strategy/"
                      className="flex px-4 py-1 child-item"
                    >
                      Building IP Strategy
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/ip-advisory-and-opinions/ip-patent-research-analytics/"
                      className="flex px-4 py-1 child-item"
                    >
                      Research & Analytics
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/ip-advisory-and-opinions/ibc-advisory/"
                      className="flex px-4 py-1 child-item"
                    >
                      IBC Advisory
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/ip-advisory-and-opinions/data-protection/"
                      className="flex px-4 py-1 child-item"
                    >
                      Advisories on Data Protection
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/outlook-of-e-commerce-and-retail-industry-in-india/"
                      className="flex px-4 py-1 child-item"
                    >
                      Advisories on E-Commerce And Retail
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/advisories-on-banking-and-financial-sectors/"
                      className="flex px-4 py-1 child-item"
                    >
                      Advisories On Banking And Financial Sectors
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/ip-advisory-and-opinions/open-source-software-oss-practice/"
                      className="flex px-4 py-1 child-item"
                    >
                      Open Source Software Practice
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav2-item pipe">
                |
              </li>
              <li className="nav2-item relative">
                <a
                  href="https://www.khuranaandkhurana.com/commercial-law-practice/"
                  className="flex md:inline-flex p-2 items-center nav2-item"
                >
                  <span style={{ fontSize: 14 }}>COMMERCIAL LAW PRACTICE</span>
                </a>
                <ul className="child transition duration-300 md:absolute top-full md:w-64 md:shadow-lg">
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/wp-content/uploads/2019/04/Corporate-and-Commercial-Law-Practice-Brochure.pdf"
                      className="flex px-4 py-1 child-item"
                    >
                      Commercial Law Practice Brochure
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/commercial-law-practice/commercial-litigation/"
                      className="flex px-4 py-1 child-item"
                    >
                      Commercial Litigation
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/company-law-practice/"
                      className="flex px-4 py-1 child-item"
                    >
                      Company Law Practice
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/labour-laws/"
                      className="flex px-4 py-1 child-item"
                    >
                      Labour Law Practice
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/fashion-law/"
                      className="flex px-4 py-1 child-item"
                    >
                      Fashion Law Practice
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/commercial-law-practice/contractagreement-drafting/"
                      className="flex px-4 py-1 child-item"
                    >
                      Contract/Agreement Drafting And Vetting
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/commercial-law-practice/nclt/"
                      className="flex px-4 py-1 child-item"
                    >
                      NCLT Practice
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav2-item pipe">
                |
              </li>
              <li className="nav2-item">
                <a
                  href="https://www.khuranaandkhurana.com/sports-law-practice/"
                  className="flex md:inline-flex p-2 items-center nav2-item"
                >
                  <span style={{ fontSize: 14 }}>SPORTS LAW PRACTICE</span>
                </a>
              </li>
              <li className="nav2-item pipe">
                |
              </li>
              <li className="nav2-item ">
                <a
                  href="https://www.khuranaandkhurana.com/media-entertainment/"
                  className="flex md:inline-flex p-2 items-center nav2-item"
                >
                  <span style={{ fontSize: 14 }}>MEDIA & ENTERTAINMENT</span>
                </a>
              </li>
              <li className="nav2-item pipe">
                |
              </li>
              <li className="nav2-item relative">
                <a
                  href="https://www.khuranaandkhurana.com/taxation/"
                  className="flex md:inline-flex p-2 items-center nav2-item"
                >
                  <span style={{ fontSize: 14 }}>TAXATION PRACTICE</span>
                </a>
                <ul className="child transition duration-300 md:absolute top-full md:w-64 md:shadow-lg">
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/wp-content/uploads/2018/11/Litigation-1.pdf"
                      className="flex px-4 py-1 child-item"
                    >
                      Taxation Practice Brochure
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/indirect-taxation/"
                      className="flex px-4 py-1 child-item"
                    >
                      Indirect Taxation
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/income-tax-advisory/"
                      className="flex px-4 py-1 child-item"
                    >
                      Income Tax Advisory
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/rd-oriented-tax-advisory/"
                      className="flex px-4 py-1 child-item"
                    >
                      R&D Oriented Tax Advisory
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/tax/gst/"
                      className="flex px-4 py-1 child-item"
                    >
                      Goods and Service Tax
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav2-item pipe">
                |
              </li>
              <li className="nav2-item ">
                <a
                  href="https://www.khuranaandkhurana.com/international-practices/"
                  className="flex md:inline-flex p-2 items-center nav2-item"
                >
                  <span style={{ fontSize: 14 }}>INTERNATIONAL PRACTICE </span>
                </a>
                <ul className="child transition duration-300 md:absolute top-full md:w-64 md:shadow-lg">
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/international-offices/"
                      className="flex px-4 py-1 child-item"
                    >
                      International Offices
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/international-practices/patent-in-bangladesh/"
                      className="flex px-4 py-1 child-item"
                    >
                      BANGLADESH
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/international-practices/patents-in-myanmar/"
                      className="flex px-4 py-1 child-item"
                    >
                      MYANMAR
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/international-practices/patents-in-nepal/"
                      className="flex px-4 py-1 child-item"
                    >
                      Nepal
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/international-practices/patents-in-vietnam/"
                      className="flex px-4 py-1 child-item"
                    >
                      Vietnam
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/international-practices/ip-practice-in-sri-lanka/"
                      className="flex px-4 py-1 child-item"
                    >
                      Sri Lanka
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/ip-practice-in-malaysia/"
                      className="flex px-4 py-1 child-item"
                    >
                      Malaysia
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.khuranaandkhurana.com/international-practices/ip-practice-in-thailand/"
                      className="flex px-4 py-1 child-item"
                    >
                      Thailand
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
        </Hidden>
      </div>
    </div>
  );
};

export default Navbar;
